
export const TREASURY_TYPES = [
    {value:'Bills',display:'Bills'},
    {value:'Notes', display:'Notes'},
    {value:'Bonds', display:'Bonds'},
    {value:'FRN', display:'FRN'},
    {value:'TIPS', display:'TIPS'},
    {value:'STRIPS', display:'STRIPS'}
].map((a) => {
    a.label = a.display
    a.value = 'holdTreasuryType=' + encodeURIComponent(a.value)
    return a
})



// WEBPACK FOOTER //
// ./src/twd/values/treasury-types.js